import CurrentTime from './CurrentTime'

export default class ActualCurrentTime extends CurrentTime {
  get now(): Date {
    return new Date()
  }
}
